export default {
    'Color Code': 'Code couleur',
    'Cancel': 'Annuler',
    'Ok': 'Valider',
    'Select color': 'Sélectionner une couleur',
}